export const holidaySteps = {
  HOTEL_INFORMATION: "hotelInformation",
  TRAVEL: "travel",
  FLIGHT: "flight",
  MEAL_TYPE: "mealType",
  ACCOMMODATION: "accommodation",
  SUMMARY: "summary",
};
